import '../../styles/MFABulkForm.css';
import React, { useState } from 'react';
import { FormGroup, Label, Input, Alert } from "reactstrap";
import { Spinner, Button, Table } from "react-bootstrap";
import Papa from 'papaparse';
import env from 'react-dotenv';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../../auth/authConfig';

export const MFABulkForm = () => {
    const [methods, setMethods] = useState(null);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState(null);
    const [csvData, setCsvData] = useState(null);
    const { instance, accounts } = useMsal();

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (file) {
            Papa.parse(file, {
                header: true,
                skipEmptyLines: true,
                complete: (result) => {
                    const filtered = result.data.filter(row =>
                        row.UserPrincipalName &&
                        row.UserPrincipalName !== 'john.doe@ecolab.com' && 
                        row.UserPrincipalName.includes('@')
                    );
                    setCsvData(filtered);
                },
                error: (error) => {
                    setMessage({ type: 'danger', text: `Error parsing CSV file: ${error.message}` });
                }
            });
        }
    };

    const handleAddMFAFromCSV = async () => {
        if (!csvData || csvData.length === 0) {
            setMessage({ type: 'warning', text: 'No valid data found in the uploaded CSV file.' });
            return;
        }

        setLoading(true);
        setMessage(null);

        let processedRows = [];

        let tokenResponse;
        try {
            tokenResponse = await instance.acquireTokenSilent({
                ...loginRequest,
                account: accounts[0],
            });
        } catch (e) {
            setLoading(false);
            setMessage({ type: 'danger', text: 'Authentication failed. Please login again.' });
            return;
        }


        for (const row of csvData) {
            const { UserPrincipalName, MethodType, PhoneNumber, PhoneType } = row;
            if (!UserPrincipalName || !MethodType || !PhoneNumber || !PhoneType) {
                processedRows.push({ ...row, status: 'Missing required fields.' });
                continue;
            }

            let response;
            try {
                response = await fetch(env.API_BULK_MFA_METHOD_ENDPOINT, {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${tokenResponse.accessToken}`,
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        UserId: UserPrincipalName,
                        MethodType: MethodType,
                        PhoneNumber: PhoneNumber,
                        PhoneType: PhoneType
                    })
                });

                if (response.status === 200) {
                    let data;
                    try {
                        data = await response.json();
                    } catch {
                        data = {};
                    }
                    if ((data.Status && data.Status.toLowerCase() === "failed") || (data.Message && data.Message.toLowerCase().includes("User Not Found"))) {
                        processedRows.push({ ...row, status: data.Message || "User Not Found" });
                    } else {
                        processedRows.push({ ...row, status: "Added" });
                    }
                } else {
                    let errorText = await response.text();
                    processedRows.push({ ...row, status: errorText });
                }
            } catch (err) {
                processedRows.push({ ...row, status: err.message });
            }
        }

        setMethods(processedRows);

        const total = processedRows.length;
        const failed = processedRows.filter(row => row.status !== "Added").length;

        if (failed === 0) {
            setMessage({ type: 'success', text: 'All MFA details successfully added from CSV.' });
        } else if (failed === total) {
            setMessage({ type: 'danger', text: 'Failed to add all MFA methods.' });
        } else {
            setMessage({ type: 'warning', text: 'Failed to add one or more MFA methods.' });
        }

        setLoading(false);
    };

    return (
        <div className="MFABulkFormContainer">
            <h3 className="formHeading">
                MFA Bulk Upload
            </h3>
            <div className='MFABulkForm space-above'>
                <FormGroup>
                    <Label for="csvFile">Upload CSV File</Label>
                    <Input
                        type="file"
                        id="csvFile"
                        accept=".csv"
                        onChange={handleFileUpload}
                        disabled={loading}
                        className="wide-file-input"
                    />
                </FormGroup>

                <Button
                    disabled={loading || !csvData}
                    onClick={handleAddMFAFromCSV}
                    className='button'
                    style={{ width: 'auto', height: '38px', margin: '2px' }}
                >
                    {loading ? <Spinner animation='border' size='sm' /> : 'Add MFA from CSV'}
                </Button>
                <a
                    href={"./MFATemplate.csv"}
                    className="btn btn-secondary button"
                    style={{ width: 'auto', height: '38px', margin: '2px', display: 'inline-block' }}
                    download
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Download CSV Template
                </a>
                {message && (
                    <div className="mt-3">
                        <Alert color={message.type}>{message.text}</Alert>
                    </div>
                )}
                

                {methods && methods.length > 0 &&(
                    <div className="mt-3">
                        <Label>MFA Details Added:</Label>
                        <Table striped bordered hover className="mfa-table">
                            <thead>
                                <tr>
                                    <th>UserPrincipalName</th>
                                    <th>MethodType</th>
                                    <th>PhoneNumber</th>
                                    <th>PhoneType</th>
                                    <th>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {methods.map((method, index) => (
                                    <tr key={index}>
                                        <td>{method.UserPrincipalName}</td>
                                        <td>{method.MethodType}</td>
                                        <td>{method.PhoneNumber}</td>
                                        <td>{method.PhoneType}</td>
                                        <td>{method.status}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                )}
            </div>
        </div>
    );
};
